import { GridColumnType } from "../../../../data/gridColumnType";

export const CriteriaListingConfig = {
  columns: [
    {
      name: "Channel",
      fieldName: "channelName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Criteria Name",
      fieldName: "criteriaName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      fieldName: "action",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "Edit",
          // iconName: AppIcons.copyIcon,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
        {
          name: "Duplicate",
          // iconName: AppIcons.copyIcon,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
